module.exports = __webpack_public_path__ + "static/img/3.ef0dfec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gczp/images/3.png
// module id = CY7m
// module chunks = 1